import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {appRoutes} from './app.routes';

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts